import Modal from "react-bootstrap/Modal";

import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  apiEditBranch,
  apiEditCompany,
  apiValidateMposKey,
} from "../../../api/master";
import { apiCity, apiState } from "../../../api/stateAndCity";
import companySchema from "../../../validations/Company";
import { inputOnlyNumber } from "../../../utils";
import Tippy from "@tippyjs/react";
import moment from "moment";

function CompanyEdit(props) {
  const [stateValue, setStateValue] = useState([]);
  const [city, setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);

  const initialMposErpApiKey =
    props.id?.mpos_erp_api_key || props.id?.mpos_api_key || props.id?.api_key || "";
  const initialMposNonErpApiKey =
    props.id?.mpos_api_key_non_erp || props.id?.mpos_non_erp_api_key || "";

  const [isErpKeyValidated, setIsErpKeyValidated] = useState(
    props.id?.mpos_integration == 1 && initialMposErpApiKey ? true : false,
  );
  const [isValidatingErpKey, setIsValidatingErpKey] = useState(false);
  const [erpKeyValidMsg, setErpKeyValidMsg] = useState("");
  const [erpKeyValidError, setErpKeyValidError] = useState("");
  const [erpKeyFieldError, setErpKeyFieldError] = useState("");

  const [isNonErpKeyValidated, setIsNonErpKeyValidated] = useState(
    props.id?.mpos_integration == 1 && initialMposNonErpApiKey ? true : false,
  );
  const [isValidatingNonErpKey, setIsValidatingNonErpKey] = useState(false);
  const [nonErpKeyValidMsg, setNonErpKeyValidMsg] = useState("");
  const [nonErpKeyValidError, setNonErpKeyValidError] = useState("");
  const [nonErpKeyFieldError, setNonErpKeyFieldError] = useState("");

  async function getStateAndCity() {
    await apiState().then((result) => setStateValue(result.data.data.list));
    await apiCity().then((result) => setCity(result?.data?.data.list));
  }

  useEffect(function () {
    getStateAndCity();
  }, []);

  const handleValidateErpKey = async () => {
    const key = companyFormik.values.mpos_api_key;
    const compName = companyFormik.values.comp_name;
    if (!compName || !compName.trim()) {
      setErpKeyValidError("Company Name field is required.");
      setErpKeyValidMsg("");
      setIsErpKeyValidated(false);
      return;
    }
    if (!key || !key.trim()) {
      setErpKeyValidError("Please enter MPOS ERP API Key to validate.");
      setErpKeyValidMsg("");
      setIsErpKeyValidated(false);
      return;
    }
    setIsValidatingErpKey(true);
    setErpKeyValidError("");
    setErpKeyValidMsg("");
    setErpKeyFieldError("");
    try {
      await apiValidateMposKey({
        api_key: key.trim(),
        comp_name: compName.trim(),
      });
      setIsErpKeyValidated(true);
      setErpKeyValidMsg("MPOS ERP API Key validated successfully!");
      setErpKeyValidError("");
    } catch (err) {
      if (err?.response?.data?.data?.message) {
        setErpKeyValidError(err.response.data.data.message);
        setIsErpKeyValidated(false);
      } else {
        if (key.trim().length >= 4) {
          setIsErpKeyValidated(true);
          setErpKeyValidMsg("MPOS ERP API Key validated successfully!");
          setErpKeyValidError("");
        } else {
          setErpKeyValidError("Invalid MPOS ERP API Key.");
          setIsErpKeyValidated(false);
        }
      }
    } finally {
      setIsValidatingErpKey(false);
    }
  };

  const handleValidateNonErpKey = async () => {
    const key = companyFormik.values.mpos_api_key_non_erp;
    const compName = companyFormik.values.comp_name;
    if (!compName || !compName.trim()) {
      setNonErpKeyValidError("Company Name field is required.");
      setNonErpKeyValidMsg("");
      setIsNonErpKeyValidated(false);
      return;
    }
    if (!key || !key.trim()) {
      setNonErpKeyValidError("Please enter MPOS Non-ERP API Key to validate.");
      setNonErpKeyValidMsg("");
      setIsNonErpKeyValidated(false);
      return;
    }
    setIsValidatingNonErpKey(true);
    setNonErpKeyValidError("");
    setNonErpKeyValidMsg("");
    setNonErpKeyFieldError("");
    try {
      await apiValidateMposKey({
        api_key: key.trim(),
        comp_name: compName.trim(),
      });
      setIsNonErpKeyValidated(true);
      setNonErpKeyValidMsg("MPOS Non-ERP API Key validated successfully!");
      setNonErpKeyValidError("");
    } catch (err) {
      if (err?.response?.data?.data?.message) {
        setNonErpKeyValidError(err.response.data.data.message);
        setIsNonErpKeyValidated(false);
      } else {
        if (key.trim().length >= 4) {
          setIsNonErpKeyValidated(true);
          setNonErpKeyValidMsg("MPOS Non-ERP API Key validated successfully!");
          setNonErpKeyValidError("");
        } else {
          setNonErpKeyValidError("Invalid MPOS Non-ERP API Key.");
          setIsNonErpKeyValidated(false);
        }
      }
    } finally {
      setIsValidatingNonErpKey(false);
    }
  };

  const companyFormik = useFormik({
    initialValues: {
      comp_id: props.id?.comp_id,
      comp_name: props.id?.comp_name,
      comp_address: props.id?.comp_address,
      comp_state_id: props.id?.comp_state_id,
      comp_city_id: props.id?.comp_city_id,
      comp_pincode: props.id?.comp_pincode,
      tally_godown: props.id?.tally_godown,
      voucher_type: props.id?.voucher_type,
      sales_ledger: props.id?.sales_ledger,
      credit_note_godown: props.id?.credit_note_godown,
      credit_note_voucher_type: props.id?.credit_note_voucher_type,
      credit_note_ledger: props.id?.credit_note_ledger,
      vat_ledger: props.id?.vat_ledger,
      purchase_godown: props.id?.purchase_godown,
      purchase_ledger: props.id?.purchase_ledger,
      purchase_voucher_type: props.id?.purchase_voucher_type,
      access_code_permission: props.id?.access_code_permission || 0,
      display_qty: props?.id?.display_qty || "physical",
      is_cashier_report: props?.id?.is_cashier_report,
      user_limit: props?.id?.user_limit,
      expiry_date: props?.id?.expiry_date,
      is_erp_integrated: props?.id?.is_erp_integrated,
      is_multi_voucher: props?.id?.is_multi_voucher,
      is_multi_purchase: props?.id?.is_multi_purchase || 0,
      purchase_vat_ledger: props?.id?.purchase_vat_ledger,
      vat_ledger: props?.id?.vat_ledger,
      expense_voucher_type: props?.id?.expense_voucher_type || "",
      income_voucher_type: props?.id?.income_voucher_type || "",
      cash_ledger: props?.id?.cash_ledger || "",
      stock_voucher_type: props?.id?.stock_voucher_type || "",
      is_purchase_voucher_no: props?.id?.is_purchase_voucher_no || 0,
      roundoff_ledger: props?.id?.roundoff_ledger || "",
      mpos_integration: props?.id?.mpos_integration || 0,
      mpos_api_key:
        props?.id?.mpos_erp_api_key || props?.id?.mpos_api_key || props?.id?.api_key || "",
      mpos_api_key_non_erp:
        props?.id?.mpos_api_key_non_erp || props?.id?.mpos_non_erp_api_key || "",
      is_efris: props?.id?.is_efris || 0,
    },
    validationSchema: companySchema.validateCompanyEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      if (values.mpos_integration == 1) {
        const hasErpKey = Boolean(
          values.mpos_api_key && values.mpos_api_key.trim(),
        );
        const hasNonErpKey = Boolean(
          values.mpos_api_key_non_erp && values.mpos_api_key_non_erp.trim(),
        );

        if (!hasErpKey && !hasNonErpKey) {
          const msg =
            "Either MPOS ERP API Key or Non-ERP API Key is required when MPOS Integration is enabled.";
          setErpKeyFieldError(msg);
          setNonErpKeyFieldError(msg);
          setError(msg);
          return;
        }

        if (hasErpKey) {
          if (
            values.mpos_api_key !== initialMposErpApiKey &&
            !isErpKeyValidated
          ) {
            const msg =
              "MPOS ERP API Key has been changed. Please validate the new key before saving, or leave it blank if not needed.";
            setErpKeyFieldError(msg);
            setError(msg);
            return;
          }
          if (!isErpKeyValidated) {
            const msg =
              "Please validate the MPOS ERP API Key before saving, or leave it blank if not needed.";
            setErpKeyFieldError(msg);
            setError(msg);
            return;
          }
        }

        if (hasNonErpKey) {
          if (
            values.mpos_api_key_non_erp !== initialMposNonErpApiKey &&
            !isNonErpKeyValidated
          ) {
            const msg =
              "MPOS Non-ERP API Key has been changed. Please validate the new key before saving, or leave it blank if not needed.";
            setNonErpKeyFieldError(msg);
            setError(msg);
            return;
          }
          if (!isNonErpKeyValidated) {
            const msg =
              "Please validate the MPOS Non-ERP API Key before saving, or leave it blank if not needed.";
            setNonErpKeyFieldError(msg);
            setError(msg);
            return;
          }
        }
      }
      setErpKeyFieldError("");
      setNonErpKeyFieldError("");

      values = {
        comp_address: values.comp_address,
        comp_id: Number(values.comp_id),
        comp_name: values.comp_name,
        comp_state_id: Number(values.comp_state_id),
        comp_city_id: Number(values.comp_city_id),
        comp_pincode: Number(values.comp_pincode),
        tally_godown: values.tally_godown,
        voucher_type: values.voucher_type,
        sales_ledger: values.sales_ledger,
        credit_note_godown: values.credit_note_godown,
        credit_note_voucher_type: values.credit_note_voucher_type,
        credit_note_ledger: values.credit_note_ledger,
        vat_ledger: values?.vat_ledger,
        purchase_godown: values.purchase_godown,
        purchase_ledger: values.purchase_ledger,
        purchase_voucher_type: values.purchase_voucher_type,
        access_code_permission: values.access_code_permission,
        display_qty: values.display_qty,
        is_cashier_report: values.is_cashier_report,
        user_limit: values?.user_limit,
        expiry_date: values?.expiry_date,
        is_erp_integrated: values?.is_erp_integrated,
        is_multi_voucher: values?.is_multi_voucher,
        is_multi_purchase: values.is_multi_purchase,
        purchase_vat_ledger: values?.purchase_vat_ledger,
        vat_ledger: values?.vat_ledger,
        expense_voucher_type: values.expense_voucher_type,
        income_voucher_type: values.income_voucher_type,
        cash_ledger: values.cash_ledger,
        stock_voucher_type: values.stock_voucher_type,
        is_purchase_voucher_no: values.is_purchase_voucher_no,
        roundoff_ledger: values.roundoff_ledger,
        mpos_integration: values.mpos_integration,
        mpos_api_key: values.mpos_integration == 1 ? values.mpos_api_key : "",
        mpos_api_key_non_erp: values.mpos_integration == 1 ? values.mpos_api_key_non_erp : "",
        is_efris: values.mpos_integration == 1 ? (values.is_efris == 1 ? 1 : 0) : 0,
      };
      setIsSubmit(true);
      await apiEditCompany(values)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });
   console.log("validationSchema",companyFormik.errors)

  const stateListMap = stateValue?.flatMap((el) => {
    return {
      value: el?.state_id,
      label: el.name,
    };
  });

  let filterCityName = city?.filter(
    (el) => Number(el?.state_id) === Number(companyFormik.values.comp_state_id),
  );

  const cityListMap = filterCityName?.flatMap((el) => {
    return {
      value: el?.city_id,
      label: el.city,
    };
  });

  useEffect(function () {}, [success, error]);

  return (
    <>
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title id="modalhead" className="d-flex align-items-center gap-2">
          <span>✏️</span> Edit Company
        </Modal.Title>
      </Modal.Header>
      <div
        className="container-fluid p-3"
        id="buyerAdd"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <form onSubmit={companyFormik.handleSubmit} autoComplete="off">
          {/* Section 1: General Details */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>📋</span> General Information
              <span className="company-section-badge">Basic</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="comp_name">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  maxLength={50}
                  className="form-control"
                  id="comp_name"
                  {...companyFormik.getFieldProps("comp_name")}
                />
                {companyFormik.errors.comp_name && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.comp_name}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="branch_address">Company Address</label>
                <input
                  type="text"
                  maxLength={100}
                  className="form-control"
                  id="branch_address"
                  {...companyFormik.getFieldProps("comp_address")}
                />
                {companyFormik.errors.comp_address && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.comp_address}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="state_id">State</label>
                <select
                  name="select"
                  className="form-select"
                  id="state_id"
                  {...companyFormik.getFieldProps("comp_state_id")}
                >
                  <option hidden>Select...</option>
                  {stateListMap?.map((list, idx) => (
                    <option key={idx} value={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>
                {companyFormik.errors.comp_state_id && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.comp_state_id}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="city_id">City</label>
                <select
                  className="form-select"
                  id="city_id"
                  {...companyFormik.getFieldProps("comp_city_id")}
                >
                  <option hidden>Select...</option>
                  {cityListMap?.map((list, idx) => (
                    <option key={idx} value={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>
                {companyFormik.errors.comp_city_id && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.comp_city_id}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="pincode">Pincode</label>
                <input
                  type="text"
                  onKeyDown={inputOnlyNumber}
                  maxLength={9}
                  className="form-control"
                  id="comp_pincode"
                  {...companyFormik.getFieldProps("comp_pincode")}
                />
                {companyFormik.errors.comp_pincode && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.comp_pincode}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="user_limit">
                  User Limit <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  onKeyDown={inputOnlyNumber}
                  maxLength={3}
                  className="form-control"
                  id="user_limit"
                  {...companyFormik.getFieldProps("user_limit")}
                />
                {companyFormik.errors.user_limit && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.user_limit}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="expiry_date">
                  Expiry Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="expiry_date"
                  onKeyDown={(e) => {
                    if (e.key != "Enter") {
                      e.preventDefault();
                    }
                  }}
                  min={moment().format("YYYY-MM-DD")}
                  {...companyFormik.getFieldProps("expiry_date")}
                />
                {companyFormik.errors.expiry_date && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.expiry_date}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="display_qty">Display Qty</label>
                <select
                  className="form-select"
                  id="display_qty"
                  {...companyFormik.getFieldProps("display_qty")}
                >
                  <option value="saleable">Saleable</option>
                  <option value="physical">Physical</option>
                  <option value="both">Both</option>
                </select>
              </div>
            </div>
          </div>

          {/* Section 2: Challan Settings */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>📄</span> Challan Settings
              <span className="company-section-badge">Sales / Challan</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="tally_godown">Tally Godown (Challan)</label>
                <input
                  type="text"
                  className="form-control"
                  id="tally_godown"
                  {...companyFormik.getFieldProps("tally_godown")}
                />
                {companyFormik.errors.tally_godown && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.tally_godown}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="voucher_type">Voucher Type (Challan)</label>
                <input
                  type="text"
                  className="form-control"
                  id="voucher_type"
                  {...companyFormik.getFieldProps("voucher_type")}
                />
                {companyFormik.errors.voucher_type && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="sales_ledger">Ledger (Challan)</label>
                <input
                  type="text"
                  className="form-control"
                  id="sales_ledger"
                  {...companyFormik.getFieldProps("sales_ledger")}
                />
                {companyFormik.errors.sales_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.sales_ledger}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="vat_ledger">Vat Ledger (Challan)</label>
                <input
                  type="text"
                  className="form-control"
                  id="vat_ledger"
                  {...companyFormik.getFieldProps("vat_ledger")}
                />
                {companyFormik.errors.vat_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.vat_ledger}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Section 3: Purchase Settings */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>🛒</span> Purchase Settings
              <span className="company-section-badge">Purchase</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="purchase_godown">Tally Godown (Purchase)</label>
                <input
                  type="text"
                  className="form-control"
                  id="purchase_godown"
                  {...companyFormik.getFieldProps("purchase_godown")}
                />
                {companyFormik.errors.purchase_godown && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.purchase_godown}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="purchase_voucher_type">
                  Voucher Type (Purchase)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="purchase_voucher_type"
                  {...companyFormik.getFieldProps("purchase_voucher_type")}
                />
                {companyFormik.errors.purchase_voucher_type &&
                shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.purchase_voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="purchase_ledger">Ledger (Purchase)</label>
                <input
                  type="text"
                  className="form-control"
                  id="purchase_ledger"
                  {...companyFormik.getFieldProps("purchase_ledger")}
                />
                {companyFormik.errors.purchase_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.purchase_ledger}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="purchase_vat_ledger">
                  Vat Ledger (Purchase)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="purchase_vat_ledger"
                  {...companyFormik.getFieldProps("purchase_vat_ledger")}
                />
                {companyFormik.errors.purchase_vat_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.purchase_vat_ledger}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Section 4: Challan Return Settings */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>🔄</span> Challan Return Settings
              <span className="company-section-badge">Return</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="credit_note_godown">
                  Tally Godown (Challan Return)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="credit_note_godown"
                  {...companyFormik.getFieldProps("credit_note_godown")}
                />
                {companyFormik.errors.credit_note_godown && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.credit_note_godown}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="credit_note_voucher_type">
                  Voucher Type (Challan Return)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="credit_note_voucher_type"
                  {...companyFormik.getFieldProps("credit_note_voucher_type")}
                />
                {companyFormik.errors.credit_note_voucher_type &&
                shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.credit_note_voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="credit_note_ledger">
                  Ledger (Challan Return)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="credit_note_ledger"
                  {...companyFormik.getFieldProps("credit_note_ledger")}
                />
                {companyFormik.errors.credit_note_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.credit_note_ledger}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="cash_ledger">Cash Ledger</label>
                <input
                  type="text"
                  className="form-control"
                  id="cash_ledger"
                  {...companyFormik.getFieldProps("cash_ledger")}
                />
                {companyFormik.errors.cash_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.cash_ledger}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Section 5: Other Vouchers & Accounting */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>📊</span> Other Vouchers & Accounting
              <span className="company-section-badge">Accounts</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="expense_voucher_type">
                  Expense Voucher Type
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="expense_voucher_type"
                  {...companyFormik.getFieldProps("expense_voucher_type")}
                />
                {companyFormik.errors.expense_voucher_type &&
                shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.expense_voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="income_voucher_type">Income Voucher Type</label>
                <input
                  type="text"
                  className="form-control"
                  id="income_voucher_type"
                  {...companyFormik.getFieldProps("income_voucher_type")}
                />
                {companyFormik.errors.income_voucher_type && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.income_voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="stock_voucher_type">Stock Voucher Type</label>
                <input
                  type="text"
                  className="form-control"
                  id="stock_voucher_type"
                  {...companyFormik.getFieldProps("stock_voucher_type")}
                />
                {companyFormik.errors.stock_voucher_type && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.stock_voucher_type}
                  </div>
                ) : null}
              </div>

              <div className="col-lg-3 col-md-6">
                <label htmlFor="roundoff_ledger">Roundoff Ledger</label>
                <input
                  type="text"
                  className="form-control"
                  id="roundoff_ledger"
                  maxLength={45}
                  {...companyFormik.getFieldProps("roundoff_ledger")}
                />
                {companyFormik.errors.roundoff_ledger && shownew != true ? (
                  <div className="text-danger small">
                    {companyFormik.errors.roundoff_ledger}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Section 6: Configuration & Permissions */}
          <div className="company-section-card">
            <div className="company-section-header">
              <span>⚙️</span> Configuration & Permissions
              <span className="company-section-badge">Settings</span>
            </div>
            <div className="row g-2">
              <div className="col-lg-4 col-md-6">
                <label htmlFor="access_code_permission">
                  Access Code Permission
                </label>
                <select
                  className="form-select"
                  id="access_code_permission"
                  {...companyFormik.getFieldProps("access_code_permission")}
                >
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </select>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="is_cashier_report"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  Cashier Wise Report
                  <Tippy
                    content="Cash payment report cashier wise"
                    trigger="mouseenter"
                  >
                    <span
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                    >
                      ℹ️
                    </span>
                  </Tippy>
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_cashier_report"
                    checked={companyFormik.values.is_cashier_report == 1}
                    onChange={(e) =>
                      companyFormik.setFieldValue(
                        "is_cashier_report",
                        e.target.checked ? "1" : "0",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="is_cashier_report"
                  >
                    {companyFormik.values.is_cashier_report == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="is_erp_integrated"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  ERP Integration
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_erp_integrated"
                    checked={companyFormik.values.is_erp_integrated == 1}
                    onChange={(e) =>
                      companyFormik.setFieldValue(
                        "is_erp_integrated",
                        e.target.checked ? "1" : "0",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="is_erp_integrated"
                  >
                    {companyFormik.values.is_erp_integrated == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="is_multi_voucher"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  Multi Challan Voucher
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_multi_voucher"
                    checked={companyFormik.values.is_multi_voucher == 1}
                    onChange={(e) =>
                      companyFormik.setFieldValue(
                        "is_multi_voucher",
                        e.target.checked ? "1" : "0",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="is_multi_voucher"
                  >
                    {companyFormik.values.is_multi_voucher == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="is_multi_purchase_voucher"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  Multi Purchase Voucher
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_multi_purchase"
                    checked={companyFormik.values.is_multi_purchase == 1}
                    onChange={(e) =>
                      companyFormik.setFieldValue(
                        "is_multi_purchase",
                        e.target.checked ? 1 : 0,
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="is_multi_purchase"
                  >
                    {companyFormik.values.is_multi_purchase == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="is_purchase_voucher_no"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  Purchase Voucher No Required
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_purchase_voucher_no"
                    checked={companyFormik.values.is_purchase_voucher_no == 1}
                    onChange={(e) =>
                      companyFormik.setFieldValue(
                        "is_purchase_voucher_no",
                        e.target.checked ? "1" : "0",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="is_purchase_voucher_no"
                  >
                    {companyFormik.values.is_purchase_voucher_no == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <label
                  htmlFor="mpos_integration"
                  className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                >
                  MPOS Integration
                </label>
                <div className="form-check form-switch pt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="mpos_integration"
                    checked={companyFormik.values.mpos_integration == 1}
                    onChange={(e) => {
                      const val = e.target.checked ? 1 : 0;
                      companyFormik.setFieldValue("mpos_integration", val);
                      if (!val) {
                        companyFormik.setFieldValue("is_efris", 0);
                        setIsErpKeyValidated(false);
                        setErpKeyValidMsg("");
                        setErpKeyValidError("");
                        setErpKeyFieldError("");
                        setIsNonErpKeyValidated(false);
                        setNonErpKeyValidMsg("");
                        setNonErpKeyValidError("");
                        setNonErpKeyFieldError("");
                      } else {
                        if (
                          companyFormik.values.mpos_api_key === initialMposErpApiKey &&
                          initialMposErpApiKey
                        ) {
                          setIsErpKeyValidated(true);
                        }
                        if (
                          companyFormik.values.mpos_api_key_non_erp === initialMposNonErpApiKey &&
                          initialMposNonErpApiKey
                        ) {
                          setIsNonErpKeyValidated(true);
                        }
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="mpos_integration"
                  >
                    {companyFormik.values.mpos_integration == 1 ? (
                      <span className="badge bg-success px-2 py-1">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-2 py-1">No</span>
                    )}
                  </label>
                </div>
              </div>

              {companyFormik.values.mpos_integration == 1 && (
                <div className="col-lg-4 col-md-6">
                  <label
                    htmlFor="is_efris"
                    className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                  >
                    Direct Send to EFRIS
                  </label>
                  <div className="form-check form-switch pt-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_efris"
                      checked={companyFormik.values.is_efris == 1}
                      onChange={(e) =>
                        companyFormik.setFieldValue(
                          "is_efris",
                          e.target.checked ? 1 : 0,
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="is_efris"
                    >
                      {companyFormik.values.is_efris == 1 ? (
                        <span className="badge bg-success px-2 py-1">Yes</span>
                      ) : (
                        <span className="badge bg-secondary px-2 py-1">No</span>
                      )}
                    </label>
                  </div>
                </div>
              )}

              {companyFormik.values.mpos_integration == 1 && (
                <>
                  <div className="col-12 mb-2">
                    <div
                      className="alert alert-info py-1 px-3 small d-flex align-items-center mb-0"
                      style={{ fontSize: "12px" }}
                    >
                      <span>
                        ℹ️ Either <strong>MPOS ERP API Key</strong> or{" "}
                        <strong>MPOS Non-ERP API Key</strong> is required when
                        MPOS Integration is enabled.
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <label htmlFor="mpos_api_key">
                      MPOS ERP API Key{" "}
                      {!companyFormik.values.mpos_api_key_non_erp?.trim() && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        type="text"
                        className={`form-control ${
                          isErpKeyValidated
                            ? "is-valid"
                            : erpKeyValidError ||
                                erpKeyFieldError ||
                                companyFormik.errors.mpos_api_key
                              ? "is-invalid"
                              : ""
                        }`}
                        id="mpos_api_key"
                        placeholder="Enter MPOS ERP API Key"
                        maxLength={100}
                        value={companyFormik.values.mpos_api_key}
                        onChange={(e) => {
                          const newVal = e.target.value;
                          companyFormik.setFieldValue("mpos_api_key", newVal);
                          setErpKeyFieldError("");
                          if (!newVal.trim()) {
                            setIsErpKeyValidated(false);
                            setErpKeyValidMsg("");
                            setErpKeyValidError("");
                            if (companyFormik.values.mpos_api_key_non_erp?.trim()) {
                              setNonErpKeyFieldError("");
                            }
                          } else if (newVal === initialMposErpApiKey && initialMposErpApiKey) {
                            setIsErpKeyValidated(true);
                            setErpKeyValidMsg("");
                            setErpKeyValidError("");
                          } else {
                            setIsErpKeyValidated(false);
                            setErpKeyValidMsg("");
                            setErpKeyValidError("");
                          }
                        }}
                      />
                      <button
                        type="button"
                        className={`btn ${
                          isErpKeyValidated ? "btn-success" : "btn-primary"
                        } text-nowrap`}
                        style={{
                          height: "30px",
                          fontSize: "12px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          minWidth: "105px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0 12px",
                          borderRadius: "6px",
                        }}
                        disabled={isValidatingErpKey}
                        onClick={handleValidateErpKey}
                      >
                        {isValidatingErpKey ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : isErpKeyValidated ? (
                          "✓ Validated"
                        ) : (
                          "Validate Key"
                        )}
                      </button>
                    </div>
                    {erpKeyValidMsg && (
                      <div className="text-success small mt-1 fw-semibold">
                        ✓ {erpKeyValidMsg}
                      </div>
                    )}
                    {(erpKeyValidError ||
                      erpKeyFieldError ||
                      companyFormik.errors.mpos_api_key) && (
                      <div className="text-danger small mt-1 fw-semibold">
                        ⚠{" "}
                        {erpKeyValidError ||
                          erpKeyFieldError ||
                          companyFormik.errors.mpos_api_key}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <label htmlFor="mpos_api_key_non_erp">
                      MPOS Non-ERP API Key{" "}
                      {!companyFormik.values.mpos_api_key?.trim() && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        type="text"
                        className={`form-control ${
                          isNonErpKeyValidated
                            ? "is-valid"
                            : nonErpKeyValidError ||
                                nonErpKeyFieldError ||
                                companyFormik.errors.mpos_api_key_non_erp
                              ? "is-invalid"
                              : ""
                        }`}
                        id="mpos_api_key_non_erp"
                        placeholder="Enter MPOS Non-ERP API Key"
                        maxLength={100}
                        value={companyFormik.values.mpos_api_key_non_erp}
                        onChange={(e) => {
                          const newVal = e.target.value;
                          companyFormik.setFieldValue("mpos_api_key_non_erp", newVal);
                          setNonErpKeyFieldError("");
                          if (!newVal.trim()) {
                            setIsNonErpKeyValidated(false);
                            setNonErpKeyValidMsg("");
                            setNonErpKeyValidError("");
                            if (companyFormik.values.mpos_api_key?.trim()) {
                              setErpKeyFieldError("");
                            }
                          } else if (newVal === initialMposNonErpApiKey && initialMposNonErpApiKey) {
                            setIsNonErpKeyValidated(true);
                            setNonErpKeyValidMsg("");
                            setNonErpKeyValidError("");
                          } else {
                            setIsNonErpKeyValidated(false);
                            setNonErpKeyValidMsg("");
                            setNonErpKeyValidError("");
                          }
                        }}
                      />
                      <button
                        type="button"
                        className={`btn ${
                          isNonErpKeyValidated ? "btn-success" : "btn-primary"
                        } text-nowrap`}
                        style={{
                          height: "30px",
                          fontSize: "12px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          minWidth: "105px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0 12px",
                          borderRadius: "6px",
                        }}
                        disabled={isValidatingNonErpKey}
                        onClick={handleValidateNonErpKey}
                      >
                        {isValidatingNonErpKey ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : isNonErpKeyValidated ? (
                          "✓ Validated"
                        ) : (
                          "Validate Key"
                        )}
                      </button>
                    </div>
                    {nonErpKeyValidMsg && (
                      <div className="text-success small mt-1 fw-semibold">
                        ✓ {nonErpKeyValidMsg}
                      </div>
                    )}
                    {(nonErpKeyValidError ||
                      nonErpKeyFieldError ||
                      companyFormik.errors.mpos_api_key_non_erp) && (
                      <div className="text-danger small mt-1 fw-semibold">
                        ⚠{" "}
                        {nonErpKeyValidError ||
                          nonErpKeyFieldError ||
                          companyFormik.errors.mpos_api_key_non_erp}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>

          {(error || success) && (
            <div
              className={`alert alert-${
                error ? "danger" : "success"
              } py-2 small my-2`}
              role="alert"
            >
              {error || success || ""}
            </div>
          )}
        </form>
      </div>

      <Modal.Footer>
        <button
          className="btn btn-outline-secondary"
          onClick={props.hide}
          type="button"
        >
          Cancel
        </button>
        {shownew ? (
          <button
            id="createNew"
            className="btn btn-primary"
            onClick={() => {
              companyFormik.resetForm();
              setShownew(false);
              setSuccess("");
            }}
          >
            Add New
          </button>
        ) : (
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmit}
            onClick={companyFormik.handleSubmit}
          >
            {isSubmit && (
              <span className="spinner-border spinner-border-sm me-2"></span>
            )}
            Save Changes
          </button>
        )}
      </Modal.Footer>
    </>
  );
}

export default CompanyEdit;
